<template>
  <layout-default>
    <template v-slot:toolbar>
      <screeners-filters
        :status="queryParams.status"
        :type="queryParams.type"
        :loading="loading"
        @search-clear="searchClear"
        @search-on:input="searchInput" />
    </template>
    <div id="screener" class="v-inner--wrap">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <inner-drawer :routes="screenersPaths">
        <template v-slot:header>
          
        </template>
      </inner-drawer>
      <inner-content />
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import InnerDrawer from "@/components/InnerDrawer.vue"
import InnerContent from "@/components/InnerContent.vue"
import LayoutDefault from '../layouts/LayoutDefault.vue'
import axios from 'axios'
import RouterMixin from "@/mixins/router"
import ScreenersFilters from '@/components/screeners/ScreenersFilters.vue'
import { childrenPaths as screenersPaths } from "@/router/paths/screenersPaths"
import { debounce } from "@/helpers/debounce"

export default {
  name: 'Practice',
  components: {
    InnerDrawer,
    InnerContent,
    ScreenersFilters,
    LayoutDefault,
  },
  mixins: [RouterMixin],
  data () {
    return {
      screenersPaths,
      defaultQueryParams: {
        pageSize: 50,
        surveyDefinition: this.$route.params.id
      },
      currentParams: {}
    }
  },
  mounted () {
  },
  computed: {
    ...mapState('screenersStates', [
      'screenerTemplateParticipants',
      'loading'
    ]),
    ...mapState('userStates', [
      'profileId',
    ]),
    screenerId () {
      return this.$route.params.id
    },
  },
  methods: {
    ...mapActions('screenersStates', [
      'getScreenerTemplateParticipants',
    ]),
    searchClear() {
      this.currentParams = {}
      this.getDataAction({ ...this.defaultQueryParams })
    },
    searchInput ({ key, value }) {
      this.currentParams[key]=value
      if (value===null) delete this.currentParams[key]
      debounce(() => {
        this.getDataAction({ ...this.defaultQueryParams, ...this.currentParams })
      },1000, 'screenersFilters')

    },
  }
}
</script>
<style lang="scss">
.practice_filters {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  width: 100%;
  .upload-file-area {
    transition-duration: 300ms;
    &.disabled {
      opacity: 0.5;
      cursor: default;
    }
  }
  .v-btn {
    margin-right: 10px;
    .v-icon {
      margin-right: 10px;
    }
  }
  .file-uploads label {
    cursor: pointer;
  }
}
</style>